import Vue from 'vue'
import App from './App.vue'
import Router from './router'
import Store from './store'
import VueI18n from 'vue-i18n'
import { Settings as LuxonSettings } from 'luxon'

import Meta from 'vue-meta'
import VueChartist from 'vue-chartist'
import VueGoogleCharts from 'vue-google-charts'
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import "./filters"
import axios from 'axios'

Vue.use(Meta)
Vue.use(vue2Dropzone)
Vue.use(VueChartist)
Vue.use(VueGoogleCharts)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime)

Vue.config.productionTip = false

Vue.config.productionTip = false

const messages = {
  fr: {
    or: "OU",
    and: "ET",
    averageExpenseInfo: "Montant total dépensé en moyenne par les clients sur la période",
    report: "Rapport",
    rank: "RANG",
    brands: "MARQUES",
    articles: "ARTICLES",
    percentage: "RATIOS",
    shops: "MAGASINS",
    tickets: "TICKETS",
    families: 'FAMILLES',
    brand: {
      info: "Marques les plus achetées (en volume) par ces clients durant la période ",
      title: "Top Marques",
      description: "(Tout produit, en quantité d'articles)",
    },
    ca: {
      info: "Chiffre d'affaire de tous les tickets faits par les clients sur la période",
      title: "CA sur la période",
      description: "(En milliers {currency})",
      unitWithoutTaxes: "k HT",
      unitWithTaxes: "k TTC",
      legendWithoutTaxes: "CA (HT, pour les clients identifiés)",
      legendWithTaxes: "CA (TTC, pour les clients identifiés)",
      date: "Date",
      ht: "HT",
      ttc: "TTC",
      rusPrefix: "de ",
      polPrefix: "de ",
      euroPrefix: "d' "
    },
    canal: {
      info: "Nombre de clients optin ou pas au moment de leur achat par canal (basé sur l'agrégat contactable print/email ou sms)",
      title: "Contactabilité",
      description: "(En volume)",
      optin: "Optin",
      notOptin: "Non-Optin",
      canal: "Canal",
      print: "Print",
      sms: "SMS",
      email: "Email"
    },
    carte: {
      info: "Clients ayant une carte de fidélité au moment de l'achat",
      title: "Clients Cartés / Non Cartés",
      clientsWithCard: "Clients Cartés : ",
      clientsWithoutCard: "Clients Non Cartés : ",
      clients: "Clients"
    },
    categories: {
      info: "Répartition par catégorie des achats (en volume) des clients pendant la période",
      title: "Catégories",
      description: "(en milliers d'articles)"
    },
    customersAge: {
      info: "Répartion des clients par tranche d'âge au moment de leur achat",
      title: "Âges des clients"
    },
    constructeur: {
      info: "Top 10 des marques de véhicules identifiés sur une facture pendant la période",
      title: "Top 10 Constructeurs",
      description: "(En nombre de tickets)",
    },
    constructeurExpense: {
      info: "Evolutions marques/modèles selon l'âge du véhicule",
      title: "Evolutions marques/modèles",
      description: "Selon l'âge du véhicule",
    },
    constructeurHeatmap: {
      info: "Evolutions marques/modèles selon l'âge du véhicule",
      title: "Evolutions marques/modèles",
      description: "Selon l'âge du véhicule",
    },
    famille: {
      midasInfo: "Top 10 des familles les plus achetés par les clients sur la période (en volume d'articles)",
      norautoInfo: "Top 10 des familles/GM les plus achetés par les clients sur la période (en volume d'articles)",
      title: "Top Familles",
      description: "(Tout produit, en quantité d'articles)",
    },
    header: {
      clients: "Clients",
      tickets: "Tickets (pour les clients identifiés)"
    },
    iris: {
      title: "Démographie (Données statistiques basées sur le recensement de 2013)",
      info: "Population française: Données INSEE du recensement de 2013; " +
      "Clients de l'enseigne: Données basées sur les adresses des clients et matchées à l'IRIS avec les données INSEE",
    },
    loadQuery: {
      title: "Charger une requête",
      remove: "Supprimer",
      cancel: "Annuler"
    },
    login: {
      profiles: "Profiles",
      byMobivia: "par Mobivia Database",
      googleConnect: "Connexion avec Google",
      or: "Ou",
      forAtu: "Pour ATU",
      username: "nom d'utilisateur",
      password: "mot de passe",
      rememberMe: "Se souvenir de moi",
      login: "Connexion",
      wrongAuthentificationMessage: "Mauvais nom d'utilisateur ou mot de passe !",
      unauthorizedEmail: 'Votre email n\'est pas autorisé.'
    },
    navbar: {
      logout: "Déconnexion"
    },
    nouveaux: {
      info: "Répartition des clients pour lequels c'est le premier achat ou pas durant la période. A noter que si un client fait 2 achats dans la période (dont le premier est son premier achat), il est considéré comme ancien client.",
      title: "Nouveaux / Anciens clients",
      oldClients: "Ancien clients : ",
      newClients: "Nouveaux clients : ",
      clients: "Clients",
      textWhenNoEndDateAndStartDate: "Veuillez sélectionner une date de début et une date de fin pour afficher les données de nouveaux clients"
    },
    pictoContainer: {
      basketInfo: "Montant moyen dépensé par ticket sur la période. A noter que si un critère produit est renseigné, tous les tickets de la période sont pris en compte pour tous les clients ayant au moins un ticket comprenant ce produit.",
      frequenceInfo: "Nb de passage moyen identifiés pour les clients ayant ce profil",
      frequenceTitle: "Frequence",
      averageVehicleAgeUnit: "ans",
      averageVehicleAgeLegend: "Âge moyen du véhicule (au moment de l'achat, pour les clients identifiés)",
      averageCustomerAgeUnit: "ans",
      averageCustomerAgeLegend: "Âge moyen du client (au moment de l'achat)",
      averageCustomerAgeNowLegend: "Âge moyen du client (maintenant)",
      frequencyPerYearUnit: "fois",
      frequencyPerYearLegend: "Sur la période",
      marginLegend: "De marge (HT, pour les clients identifiés)",
      averageCartTitle: "Panier moyen (Pour les clients identifiés)",
      averageCartLegend: "Panier moyen (TTC, pour les clients identifiés)",
      averagePrice: "Prix moyen (TTC, pour les clients identifiés)",
      expensesPerClientLegend: "Dépenses par client (TTC, pour les clients identifiés)",
      datePrefix: "au",
      percentageCA: "Part (en CA TTC) des produits sélectionnés.",
      percentageQuantity: "Part (en quantité) des produits sélectionnés au sein des tickets sélectionnés",
      totalDiscountLegend: "Remise totale (TTC, pour les clients identifiés) sur la période",
      discountRowsPercentLegend: "Pourcentage de factures présentant une remise (pour les clients identifiés)",
      concernedClients: "clients concernés",
      concernedTickets: "tickets concernés",
      seniority: "Ancienneté (en jours)",
    },
    produitn1: {
      midasInfo: "Top 10 des activités les plus achetées par les clients sur la période (en volume d'articles)",
      norautoAtuInfo: "Top 10 des catégories niveau 1 les plus achetées par les clients sur la période (en volume d'articles)",
      title: "Top 10 Produits Niveau 1",
      description: "(Tout produit, en quantité d'articles)"
    },
    produitn2: {
      midasInfo: "Top 10 des sous-activités les plus achetées par les clients sur la période (en volume d'articles)",
      norautoAtuInfo: "Top 10 des catégories niveau 2 les plus achetées par les clients sur la période (en volume d'articles)",
      title: "Top 10 Produits Niveau 2",
      description: "(Tout produit, en quantité d'articles)"
    },
    reachat: {
      info: "% des clients ayant réacheté au moins un des produits de(s) famille/catégorie/marque renseignée(s)",
      title: "Réachat",
      nbCustomersM3Legend: "Clients ayant réacheté ce type de produit dans le trimestre suivant :",
      nbCustomersM6Legend: "Clients réachetant ce type de produit dans le semestre suivant :",
      nbCustomersM12Legend: "Clients réachetant ce type de produit dans l'année suivante :",
      nbCustomersM24Legend: "Clients réachetant ce type de produit dans les 2 ans :",
      textWhenNoEndDate: "Veuillez sélectionner une date de fin pour afficher les données de réachat"
    },
    register: {
      title: "Choix du mot de passe",
      invalidPassword: "Mot de passe invalide : ",
      minLength: '- doit faire 8 caractères minimum',
      atLeastOneNumber: '- doit avoir au moins un chiffre',
      unmatchingPasswords: '- le mot de passe de confirmation est différent',
      registerSuccess: 'Le mot de passe a bien été enregistré !',
      backendError: "Une erreur s'est produite durant l'enregistrement !",
      password: "mot de passe",
      confPassword: "confirmation mot de passe",
      confirmer: "Confirmer"
    },
    revisite: {
      info: "% des clients étant revenus dans les 3, 6, 12 ou 24 mois après la fin de la période renseignée.",
      title: "Revisites",
      nbCustomersM3AllLegend: "Clients revenus dans le trimestre suivant :",
      nbCustomersM6AllLegend: "Clients revenus dans le semestre suivant :",
      nbCustomersM12AllLegend: "Clients revenus dans l'année :",
      nbCustomersM24AllLegend: "Clients revenus dans les 2 ans :",
      textWhenNoEndDate: "Veuillez sélectionner une date de fin pour afficher les données de revisites"
    },
    saveQuery: {
      name: "Sauvegarder la requête",
      title: "Titre : ",
      newQueryName: "New query name",
      cancel: "Annuler",
      save: "Sauvegarder",
    },
    searchName: {
      save: "Sauvegarder",
      export: "Exporter",
      delete: "Supprimer",
      import: "Importer"
    },
    sector: {
      sector: "SECTEUR",
      info: "Top 10 des secteurs de la bu",
      title: "Top 10 Secteurs",
      description: "(En nombre de tickets)"
    },
    segment: {
      info: "Répartition des clients suivant leur segment RFM au moment de l'achat",
      title: "Segments RFM"
    },
    selectFilter: {
      shopZone: "Régions",
      generalCriteria: "Critères généraux",
      clientCriteria:  "Critères clients",
      categoryLevel1: "Catégorie (Niveau 1)",
      categoryLevel2: "Catégorie (Niveau 2)",
      family: "Famille",
      codeFamily: "Code Famille",
      add: "Ajouter",
      codeProduct: "Code Produit",
      productBrand: "Marque Produit",
      addFilter: "Ajouter le filtre",
      manufacturer: "Constructeur",
      fidelity: "Fidélité",
      codeShop: "Code Magasin",
      member: "Adhérent",
      notMember: "Non-Adhérent",
      firstVisitDate: "Date de première visite",
      segment2425: "Segment RFM (24/25)",
      segment2324: "Segment RFM (23/24)",
      segment2223: "Segment RFM (22/23)",
      segment2122: "Segment RFM (21/22)",
      segment2021: "Segment RFM (20/21)",
      segment1920: "Segment RFM (19/20)",
      segment1819: "Segment RFM (18/19)",
      segment1718: "Segment RFM (17/18)",
      age: "Age du client",
      contactabilite: "Contactabilité",
      recommendedFamilies: "Familles recommandées",
      shopType: "Type de magasin",
      succursale: "Succursale",
      franchise: "Franchise",
      civilite: "Civilité",
      man: "Homme",
      woman: "Femme",
      company: "Société",
      other: "Autre",
      pass_entretien:'Pass entretien',
      nopass_entretien: 'Sans pass entretien'
    },
    shop: {
      info: "Top 10 des magasins/ateliers",
      title: "Top 10 Magasins",
      description: "(En nombre de tickets)"
    },
    sideNavbar: {
      compareNewSearch: "Comparer (nouvelle recherche)"
    },
    sideSearch: {
      modeExplanation: `
      <div>
        <div><strong>Mode Profil :</strong> Les filtres permettent de sélectionner les clients qui ont eu ce comportement. Les chiffres sur l'ensemble des achats de ces clients sont ensuite affichés.</div><br/>
        <div><strong>Mode Ticket :</strong> Le filtre cherche les clients qui ont eu ce comportement, ne sont affichés que les chiffres des tickets en question</div><br/>
      </div>`,
      radioProfileLabel: "Profil",
      radioTicketLabel: "Ticket",
      radioDetailsLabel: "Détails",
      from: "À partir du",
      until: "Jusqu'au",
      filtersList: "Liste des filtres",
      addFilter: "Ajouter un filtre",
      filter: "Filtre",
      importedCSVData: "Données CSV importées",
      items: "items",
      deleteFilter: "Supprimer le filtre"
    },
    import: {
      info: "Importer un fichier au format CSV, la première ligne du fichier doit être le nom des données ('prIdBu', 'cdProduct' ou 'cdShop') et chaque ligne est une valeur",
      import: "Importer",
      dragDrop: "Déposer un fichier ici",
      or: "ou",
      chooseFile: "Choisir un fichier"
    },
    civilities: {
      title: "Civilité",
      info: "Répartition hommes/femmes/autres (comprend les sociétés, collectivités, etc.)",
      man: "Homme",
      woman: "Femme",
      company: "Société",
      other: "Autre"
    },
    atelier: {
      info: "Répartition des clients ayant faits uniquement des achats magasin ou des achats magasin ET atelier",
      workshopClient: "Clients atelier : ",
      shopClient: "Clients uniquement magasin : ",
      title: "Clients Atelier",
      clients: "Clients"
    }
  },
  en: {
    or: "OR",
    and: "AND",
    averageExpenseInfo: "Average cumulated amount spent by the customers during the period",
    report: "Report",
    rank: "RANK",
    brands: "BRANDS",
    articles: "PRODUCTS",
    percentage: "RATIOS",
    shops: "SHOPS",
    tickets: "RECEIPS",
    families: 'FAMILIES',
    brand: {
      info: "Brands that are the most bought (in volume of items) by these customers during the period",
      title: "Top Brands",
      description: "(Every product, in quantity of articles)",
    },
    ca: {
      info: "Turnover of all the bills made by the customers during the period",
      title: "Turnover on the periode",
      description: "(In thousands {currency})",
      unitWithoutTaxes: "k excl. taxes",
      unitWithTaxes: "k incl. taxes",
      legendWithoutTaxes: "Turnover (excl. taxes)",
      legendWithTaxes: "Turnover (incl. taxes)",
      date: "Date",
      ht: "excl. taxes",
      ttc: "incl. taxes",
      rusPrefix: "of ",
      polPrefix: "of ",
      euroPrefix: "of "
    },
    canal: {
      info: "Nb of optin customers when they make their purchase / by channel (based on the contactable print/email or mobile aggregate)",
      title: "Contactability",
      description: "(In amount)",
      optin: "Optin",
      notOptin: "Not-Optin",
      canal: "Communication channel",
      print: "Print",
      sms: "SMS",
      email: "Email"
    },
    carte: {
      info: "Customers who have a loyalty card when they make their purchase",
      title: "[en]Clients Cartés / Non Cartés",
      clientsWithCard: "[en]Clients Cartés : ",
      clientsWithoutCard: "[en]Clients Non Cartés : ",
      clients: "Customers"
    },
    categories: {
      info: "Distribution of purchases (in volume of items) by categories during the period",
      title: "Categories",
      description: "In terms of quantity of articles"
    },
    customersAge: {
      info: "Distribution of customers by age group when they make their purchase",
      title: "Customer's age"
    },
    constructeur: {
      info: "Top 10 of vehicules'brands identified on a bill during the period",
      title: "Top 10 Constructors",
      description: "(in receips number)",
    },
    constructeurExpense: {
      info: "Evolutions brand/models",
      title: "Evolutions brand/models",
      description: "Evolutions brand/models",
    },
    constructeurHeatmap: {
      info: "Evolutions brand/models",
      title: "Evolutions brand/models",
      description: "Evolutions brand/models",
    },
    famille: {
      midasInfo: "Top 10 of the most bought families (in volume of items) by the customers on the period",
      norautoInfo: "Top 10 of the most bought families/GM (in volume of items) by the customers on the period",
      title: "Top Families",
      description: "Any product, in terms of quantity of articles",
    },
    header: {
      clients: "Customers",
      tickets: "Bills"
    },
    iris: {
      title: "Démographie (Données statistiques basées sur le recensement de 2013)",
      info: "Population française: Données INSEE du recensement de 2013 \nClients de l'enseigne: Données basées sur les adresses des clients et matchées à l'IRIS avec les données INSEE",
    },
    loadQuery: {
      title: "Load a request",
      remove: "Remove",
      cancel: "Cancel"
    },
    login: {
      profiles: "Profiles",
      byMobivia: "by Mobivia Database",
      googleConnect: "Connect with Google",
      or: "Or",
      forAtu: "For ATU",
      username: "username",
      password: "password",
      rememberMe: "Remember me",
      login: "Login",
      wrongAuthentificationMessage: "Wrong login or password !",
      unauthorizedEmail: 'Your email is not authorized.'
    },
    navbar: {
      logout: "Logout"
    },
    nouveaux: {
      info: "Distribution of customers for whom it is the first purchase or not during the period. If a customer make 2 purchases during the period (the first one is his first purchase) he is considered as an old customer.",
      title: "News / Formers customers",
      oldClients: "Formers customers : ",
      newClients: "News customers : ",
      clients: "Customers",
      textWhenNoEndDateAndStartDate: "Please select a start date and an end date to display the new customer data"
    },
    pictoContainer: {
      basketInfo: "Average amount spent by bill during the period. If a product criteria is selected, all the bills of the period ",
      frequenceInfo: "Average number of identified visits of customers",
      frequenceTitle: "Frequence",
      averageVehicleAgeUnit: "years",
      averageVehicleAgeLegend: "Average age of the vehicle",
      averageCustomerAgeUnit: "years",
      averageCustomerAgeLegend: "Average age of the customer (ticket time)" ,
      averageCustomerAgeNowLegend: "Customer average age (now)",
      frequencyPerYearUnit: "times",
      frequencyPerYearLegend: "Over the period",
      marginLegend: "Of margin excl. taxes",
      averageCartTitle: "Average cart",
      averageCartLegend: "Average cart incl. taxes",
      expensesPerClientLegend: "Expenses by customer incl. taxes",
      datePrefix: "on the",
      percentageCA: "Of revenue (with taxes)",
      percentageQuantity: "Of quantity",
      totalDiscountLegend: "Total discount (with taxes) on the period",
      discountRowsPercentLegend: "Bills with discount",
      concernedClients: "concerned clients",
      concernedTickets: "concerned tickets",
      seniority: "Seniority (in days)"
    },
    produitn1: {
      midasInfo: "Top 10 of the most bought activities (in volume of items) by the customers over the period",
      norautoAtuInfo: "Top 10 of the most bought level 1 groups (in volume of items) by the customers over the period",
      title: "Top 10 level 1 products",
      description: "(Any product, in terms of quantity of articles)"
    },
    produitn2: {
      midasInfo: "Top 10 of the most bought under-activities (in volume of items) by the customers over the period",
      norautoAtuInfo: "Top 10 of the most bought level 2 groups (in volume of items) by the customers over the period",
      title: "Top 10 level 2 products",
      description: "(Any product, in terms of quantity of articles)"
    },
    reachat: {
      info: "% of customers who have repurchased at least one of the product of the selected family/category/brand",
      title: "Re-purchase",
      nbCustomersM3Legend: "Customers who re-purchased this type of product in the following quarter :",
      nbCustomersM6Legend: "Customers who re-purchased this type of product in the following semester :",
      nbCustomersM12Legend: "Customers who re-purchased this type of product in the following year :",
      nbCustomersM24Legend: "Customers who re-purchased this type of product within 2 years :",
      textWhenNoEndDate: "Please select an end date to display the re-purchase data"
    },
    register: {
      title: "Password choice",
      invalidPassword: "Invalid password : ",
      minLength: '- must be at least 8 characters long',
      atLeastOneNumber: '- must have at least one number',
      unmatchingPasswords: '- the password and the confirmation password does not match',
      registerSuccess: 'The password has been successfullly registered!',
      backendError: "An error occurred during registration !",
      password: "password",
      confPassword: "confirmation password",
      confirmer: "Confirm"
    },
    revisite: {
      info: "% of customers who came back in the 3, 6, 12 or 24 months after the end of the selected period",
      title: "Revisits",
      nbCustomersM3AllLegend: "Customers who returned in the following quarter :",
      nbCustomersM6AllLegend: "Customers who returned in the following semester :",
      nbCustomersM12AllLegend: "Customers who returned in the following year :",
      nbCustomersM24AllLegend: "Customers who returned within 2 years :",
      textWhenNoEndDate: "Please select an ending date to display revisits data" // à avoir en même temps que revisites
    },
    saveQuery: {
      name: "Save the request",
      title: "Title : ",
      newQueryName: "New query name",
      cancel: "Cancel",
      save: "Save",
    },
    searchName: {
      save: "Save",
      export: "Export",
      delete: "Remove",
      import: "Import"
    },
    sector: {
      sector: "SECTOR",
      info: "Top 10 sectors of the bu",
      title: "Top 10 Sectors",
      description: "(in receips number)"
    },
    segment: {
      info: "Distribution of customers by RFM segment when they make their purchase",
      title: "[en]Segments RFM (18/19)"
    },
    selectFilter: {
      shopZone: "Region",
      generalCriteria: "Generals criteria",
      clientCriteria:  "Customers criteria",
      categoryLevel1: "Category (level 1)",
      categoryLevel2: "Category (level 2)",
      family: "Family",
      codeFamily: "Family code",
      add: "Add",
      codeProduct: "Product code",
      productBrand: "Brand product",
      addFilter: "Add the filter",
      manufacturer: "Constructor",
      fidelity: "Fidelity",
      codeShop: "Shop code",
      member: "Adherent",
      notMember: "Non-Member",
      firstVisitDate: "Date of first visit",
      segment2425: "Segment RFM (24/25)",
      segment2324: "Segment RFM (23/24)",
      segment2223: "Segment RFM (22/23)",
      segment2122: "Segment RFM (21/22)",
      segment2021: "Segment RFM (20/21)",
      segment1920: "Segment RFM (19/20)",
      segment1819: "Segment RFM (18/19)",
      segment1718: "Segment RFM (17/18)",
      age: "Customer's age",
      contactabilite: "Contactability",
      recommendedFamilies: "Recommended families",
      shopType: "Shop type",
      succursale: "Branch office",
      franchise: "Franchise",
      civilite: "Civility",
      man: "Men",
      woman: "Women",
      company: "Company",
      other: "Other",
      pass_entretien:'Pass entretien',
      nopass_entretien: 'Without pass entretien'
    },
    shop: {
      info: "Top 10 of shops",
      title: "Top 10 shops",
      description: "(in receips number)"
    },
    sideNavbar: {
      compareNewSearch: "Compare (new search)"
    },
    sideSearch: {
      modeExplanation: `[EN]
        <div>
          <div><strong>Mode Profil :</strong> Les filtres permettent de sélectionner les clients qui ont eu ce comportement. Les chiffres sur l'ensemble des achats de ces clients sont ensuite affichés.</div><br/>
          <div><strong>Mode Ticket :</strong> Le filtre cherche les clients qui ont eu ce comportement, ne sont affichés que les chiffres des tickets en question</div><br/>
        </div>
        `,
      radioProfileLabel: "Profile",
      radioTicketLabel: "Ticket",
      radioDetailsLabel: "Details",
      from: "From",
      until: "Until",
      filtersList: "Filters list",
      addFilter: "Add a filter",
      filter: "Filter",
      importedCSVData: "Imported CSV data",
      items: "items",
      deleteFilter: "Remove the filter"
    },
    import: {
      info: "Import a CSV file, the first line should be the data name ('prIdBu', 'cdProduct' or 'cdShop') and each line is a value",
      import: "Import",
      dragDrop: "Drop a file here",
      or: "or",
      chooseFile: "Chose a file"
    },
    civilities: {
      title: "Civility",
      info: "Distribution men/women/others (companies, local authorities, etc.)",
      man: "Man",
      woman: "Woman",
      company: "Company",
      other: "Other"
    },
    atelier: {
      info: "Distribution of customers who have bought only in shops or in shops AND workshop",
      workshopClient: "Workshop customers : ",
      shopClient: "Only shop customers : ",
      title: "Workshop customers",
      clients: "Customers"
    }
  }
}

const browserLanguage = navigator.language || navigator.userLanguage

const i18n = new VueI18n({
  locale: browserLanguage,
  fallbackLocale: 'fr',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true
})

new Vue({
  el: '#app',
  render: h => h(App),
  router: Router,
  store: Store,
  i18n,
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if(error.constructor.name != axios.Cancel.name) {
    if (error && error.response) {
      if (error.response.status === 401) {
        Router.push({path: '/login'})
      } else if (error.response.status === 403) {
        Router.push({path: '/login', query: {'lastErrorCode': 'unauthorized'}})
      }
    } else {
      return Promise.reject(error)
    }
  }
})

LuxonSettings.defaultLocale = browserLanguage

document.querySelector('meta[name="viewport"]').setAttribute("content", "")
